import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set, get) => ({
      // 状态
      isAuthenticated: false,
      admin: null,
      token: null,
      companyName: null,

      // 登录
      login: (token, admin, companyName) => {
        localStorage.setItem('admin_token', token);
        set({ isAuthenticated: true, token, admin, companyName });
      },

      // 登出
      logout: () => {
        localStorage.removeItem('admin_token');
        set({ isAuthenticated: false, token: null, admin: null, companyName: null });
      },

      // 更新管理员信息
      updateAdmin: (admin) => set({ admin }),

      // 更新公司名称
      setCompanyName: (name) => set({ companyName: name }),

      // 检查登录状态
      checkAuth: () => {
        const token = localStorage.getItem('admin_token');
        if (token) {
          set({ isAuthenticated: true, token });
        }
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ admin: state.admin, token: state.token, isAuthenticated: state.isAuthenticated, companyName: state.companyName }),
    }
  )
);

export default useAuthStore;
